import React, { useCallback } from "react";
import {
    ToggleGroup,
    ToggleGroupSize,
} from "@design-system/ToggleGroup/ToggleGroup";
import { BusinessIcon, HomeIcon } from "@icons";
import styles from "./FinancialAccountTypeSelect.module.scss";

type AccountTypeValue = "business" | "personal";

interface Props {
    showIcon?: boolean;
    showLabel?: boolean;
    value: boolean | null;
    loading?: boolean;
    disabled?: boolean;
    onChange?: (value: boolean) => void;
    size?: Exclude<ToggleGroupSize, "md">;
}

export const FinancialAccountTypeSelect: React.FC<Props> = ({
    showIcon = false,
    showLabel = true,
    value,
    loading,
    disabled,
    onChange,
    size = "lg",
}) => {
    let selectedValue: AccountTypeValue | null = null;
    if (value === true) {
        selectedValue = "business";
    } else if (value === false) {
        selectedValue = "personal";
    }

    const handleValueChange = useCallback(
        (next: AccountTypeValue | null) => {
            if (next === null) {
                return;
            }

            onChange?.(next === "business");
        },
        [onChange],
    );

    return (
        <ToggleGroup.Root<AccountTypeValue>
            className={styles.root}
            value={selectedValue}
            onValueChange={handleValueChange}
            size={size}
            disabled={disabled || loading}
        >
            <ToggleGroup.Item<AccountTypeValue>
                value="business"
                className={styles.item}
            >
                {showIcon ? <BusinessIcon /> : null}
                {showLabel ? "Business" : null}
            </ToggleGroup.Item>
            <ToggleGroup.Item<AccountTypeValue>
                value="personal"
                className={styles.item}
            >
                {showIcon ? <HomeIcon /> : null}
                {showLabel ? "Personal" : null}
            </ToggleGroup.Item>
        </ToggleGroup.Root>
    );
};
